import { render, staticRenderFns } from "./ngo-tracking-results.vue?vue&type=template&id=08fa3bf6&scoped=true&"
import script from "./ngo-tracking-results.vue?vue&type=script&lang=js&"
export * from "./ngo-tracking-results.vue?vue&type=script&lang=js&"
import style0 from "./ngo-tracking-results.vue?vue&type=style&index=0&id=08fa3bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa3bf6",
  null
  
)

export default component.exports